import { Box, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface IFingerIcon {
  label: string;
  color: string;
  icon: IconProp;
  'data-selector'?: string;
}

export const FingerIcon = (props: IFingerIcon) => {
  const { label, color, icon, 'data-selector': dataSelector } = props;

  return (
    <Tooltip hasArrow placement="top-start" label={label}>
      <Box
        data-selector={dataSelector}
        fontSize={'xl'}
        lineHeight={6}
        width={{ base: undefined, md: 10 }}
        px={{ base: 0, md: 2.5 }}
        pt={2}
        position={'relative'}
        color={`${color}.500`}
        _dark={{ color: `${color}.300` }}
      >
        <FontAwesomeIcon icon={icon} />
      </Box>
    </Tooltip>
  );
};
